export default "__VITE_ASSET__69d72380__"